import React, { Suspense, useEffect, createRef } from 'react';
import { observer } from 'mobx-react-lite';
import { useLocation, Routes, Route } from 'react-router-dom';
import { ComponentFactory } from '../../ComponentFactory';
import { AppRoutes } from '../../../core/routes';
import { useDataStore } from '../../providers/StoresProvider';
import AuthRouter from '../authrouter/AuthRouter';
import { scrollToTop } from '../../utils/WebHelper';

export interface AppProps {
  // Define any props if required for your App component.
}

const ErrorPage = React.lazy(() => ComponentFactory.ErrorPageAsync);
const Rentals = React.lazy(() => ComponentFactory.RentalsAsync);
const RentalPage = React.lazy(() => ComponentFactory.RentalPageAsync);
const CancelShowing = React.lazy(() => ComponentFactory.CancelShowingAsync);

const AppContent = observer(() => {
  const dataStore = useDataStore();
  const { userState } = dataStore;

  return userState.fetchingUser ? (
    <ComponentFactory.Loading isPage />
  ) : (
    <>
      <ComponentFactory.Header />
      <Routes>
        <Route path={AppRoutes.Rentals} element={<Rentals />} />
        <Route path={AppRoutes.RentalDetails} element={<RentalPage />} />
        <Route path={AppRoutes.CancelShowing} element={<CancelShowing />} />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
      <ComponentFactory.Footer />
    </>
  );
});

const App: React.FC<AppProps> = observer(() => {
  const { pathname, hash } = useLocation();
  const resetRef = createRef<HTMLSpanElement>();

  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.replace('#', ''));
      if (element) element.scrollIntoView({ behavior: 'smooth' });
    } else {
      scrollToTop();
      resetRef.current?.focus();
    }
  }, [pathname, hash]);

  return (
    <div>
      <span ref={resetRef} tabIndex={-1} />
      <AuthRouter>
        <Suspense fallback={<ComponentFactory.Loading isPage />}>
          <AppContent />
        </Suspense>
      </AuthRouter>
    </div>
  );
});

export default App;
